import { $Locale } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';
import { useViewTracking } from '~/utils/use-view-tracking';
import { useCallback, useMemo } from 'react';
import { kepQueryFormat } from 'shared/utils/format/kep-formatter';
import { $CurrentDiscoverKeyword } from '../../shared/atom';
import { active } from '~/utils/active';

interface IHotKeywordItemProps {
  word: string;
  index: number;
}

export const HotKeywordItem = (props: IHotKeywordItemProps): JSX.Element => {
  const { word, index } = props;
  const { region } = useAtomValue($Locale);
  const keyword = useAtomValue($CurrentDiscoverKeyword);

  const href = useMemo(() => `/discover/${kepQueryFormat(word)}?region=${region}`, [word]);

  const handleKeywordClick = useReflowClick(
    {
      reflowBehavior: () => {
        active({
          schemaOption: {
            pageType: 'search',
            query: kepQueryFormat(word),
          },
          ampExtra: {
            enter_position: ClickPosition.kep_classify_hot_keyword,
            seo_search_keyword: kepQueryFormat(word),
            seo_search_keyword_source: 'breadcrumbs_word',
            seo_position_rank: '4', // fixed position
          },
        });
      },
      clickEvent: () => ({
        page_id: keyword,
        current_position: ClickPosition.kep_classify_hot_keyword,
        current_page_module: ClickPosition.kep_classify_hot_keyword,
        page_click_id: kepQueryFormat(word),
        module_rank: 4, // fixed position
        search_keyword: kepQueryFormat(word),
        search_keyword_source: 'breadcrumbs_word',
        rank: index,
      }),
    },
    [word, active],
  );

  const kepHotKeywordObservedRef = useViewTracking<HTMLAnchorElement>({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: ClickPosition.kep_classify_hot_keyword,
        current_page_module: ClickPosition.kep_classify_hot_keyword,
        module_rank: 4, // fixed position
        group_id: kepQueryFormat(word),
        search_keyword: kepQueryFormat(word),
        search_keyword_source: 'breadcrumbs_word',
        rank: index,
      });
    }, []),
  });

  return (
    <a
      href={href}
      key={`kep-hot-keywords-module-list-item-${index}`}
      className="kep-hot-keywords-module-list-item"
      onClick={handleKeywordClick}
      ref={kepHotKeywordObservedRef}
    >
      <div key={`kep-hot-keywords-module-list-item-text-${index}`} className="kep-hot-keywords-module-list-item-text">
        {word}
      </div>
    </a>
  );
};
